import { RootState } from './types'

import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import { license } from './modules/license'
import { local } from './modules/local'
import { server } from './modules/server'
import { user } from './modules/user'
import { permission } from './modules/permission'
import { device } from './modules/device'
import { tag } from './modules/tag'
import { view } from './modules/view'
import { datalog } from './modules/datalog'
import { logical } from './modules/logical'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    version: process.env.VUE_APP_VERSION || 'V1-dev',
  },
  mutations: {},
  actions: {},
  modules: {
    license,
    local,
    server,
    user,
    permission,
    tag,
    device,
    view,
    datalog,
    logical,
  },
  getters: {
    //  eslint-disable-next-line
    roles: (state) => (state as any).user.roles,
    isSuperAdmin: (state) =>
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('superadmin') != -1,
    isInstrument: (state) =>
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('instrument') != -1,
    isAdmin: (state) =>
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('admin') != -1,
    isEditor: (state) =>
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('admin') != -1 ||
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('editor') != -1,
    isOperator: (state) =>
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('operator') != -1,
    isStandarUser: (state) =>
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('admin') != -1 ||
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('editor') != -1 ||
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('operator') != -1 ||
      //  eslint-disable-next-line
      (state as any).user.roles.indexOf('user') != -1,
    version: (state) => state.version,
  },
}

const vx = new Vuex.Store<RootState>(store)

function tick1s() {
  vx.dispatch('local/tick1s')
  vx.dispatch('server/tick1s')
  setTimeout(() => {
    tick1s()
  }, 1000)
}

tick1s()

export default vx

/** Load vuex initial data */
export async function LoadInitialData() {
  await vx.dispatch('license/getLicense')
  await vx.dispatch('server/getProjectDashboard')
  await vx.dispatch('datalog/find')

  // Fetch data tags jika belum ada
  const hasTags = vx.getters['tag/items'] && vx.getters['tag/items'].length > 0
  if (!hasTags) {
    await vx.dispatch('tag/get')
  }

  // Fetch data view jika belum tersedia
  const hasView =
    vx.getters['view/items'] && vx.getters['view/items'].length > 0
  if (!hasView) {
    await vx.dispatch('view/get')
  }
}
